module.exports = __webpack_public_path__ + "img/character-5.ee298d82.webp";